import React from 'react';
import { Container } from 'react-bootstrap';
import { Trans } from 'react-i18next';

const OutsourcingAdvantagesIntro = props => (
    <section id="outsourcing-advantages-sectionIntro" className="my pt-5 white-bg">
        {/* <div className='white-shape'></div> */}
        <Container>
            <p className='mb-0'>
                <Trans i18nKey="services:outsourcingAdvantages:section-1.txt"
                    components={{
                        br: <br />,
                        outsourcingService: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing.path')} className="link" />
                    }}
                />
            </p>
        </Container>
    </section>
);

export default OutsourcingAdvantagesIntro;
